import { useState, useEffect, useCallback } from 'react';
import PendingPromoterApplications from './PendingPromoterApplications.js';
import ApiAccessAdmin from './ApiAccessAdmin.js';

export default function UserDashboardAdmin() {
  const [stats, setStats] = useState({
    eventClicks: 0,
    bannerClicks: 0,
    icalDownloads: 0,
    savedEvents: 0
  });

  // Wrap fetchStats in useCallback
  const fetchStats = useCallback(async () => {
    try {
      const response = await fetch(
        'https://r7ej0e9i28.execute-api.ap-southeast-2.amazonaws.com/dev/adminstats'
      );
      const statsData = await response.json();
      setStats(statsData);
    } catch (err) {
      console.error('Error fetching admin stats:', err);
    }
  }, []);

  // Use fetchStats in useEffect
  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  return (
    <div className="p-1">
      {/* Stats Grid */}
      <div className="grid grid-cols-2 gap-4 mb-8">
        {/* Event Clicks */}
        <div className="bg-gradient-to-br from-slate-900 to-slate-700 rounded-lg p-4 text-center h-[100px] flex flex-col justify-center">
          <div className="text-4xl font-bold text-white">
            {stats.eventClicks || 0}
          </div>
          <div className="text-xs text-white">
            event clicks
          </div>
        </div>

        {/* Banner Clicks */}
        <div className="bg-gradient-to-br from-slate-700 to-slate-900 rounded-lg p-4 text-center h-[100px] flex flex-col justify-center">
          <div className="text-4xl font-bold text-white">
            {stats.bannerClicks || 0}
          </div>
          <div className="text-xs text-white">
            banner clicks
          </div>
        </div>

        {/* iCal Downloads */}
        <div className="bg-gradient-to-br from-slate-900 to-slate-700 rounded-lg p-4 text-center h-[100px] flex flex-col justify-center">
          <div className="text-4xl font-bold text-white">
            {stats.icalDownloads || 0}
          </div>
          <div className="text-xs text-white">
            iCal downloads
          </div>
        </div>

        {/* Saved Events */}
        <div className="bg-gradient-to-br from-slate-700 to-slate-900 rounded-lg p-4 text-center h-[100px] flex flex-col justify-center">
          <div className="text-4xl font-bold text-white">
            {stats.savedEvents || 0}
          </div>
          <div className="text-xs text-white">
            added to MyCal
          </div>
        </div>
      </div>

      {/* Pending Promoter Applications */}
      <PendingPromoterApplications alwaysShow title="Promoter Requests" />

      <ApiAccessAdmin />
    </div>
  );
} 